module.exports = __webpack_public_path__ + "static/card-products-animated-2024-753887edfe7f5b0ca63c6c3c57b65453.gif";